import { Loading } from "@dgs/core";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { useContactAttributeOptions } from "../shared/hooks/useContactAttributeOptions";
import { ContactAttributeOption } from "../shared/types";
import { EditSortableLists } from "../shared/ui/sortable_lists/EditSortableLists";

interface Props {
	value: ContactAttributeOption[];
	onChange: (sortableDataFields: ContactAttributeOption[]) => void;
	error?: string;
}

export const EditSortableContactAttributes: FC<Props> = ({ value, onChange, error }) => {
	const { t } = useTranslation();
	const { contactAttributeOptions, isLoading } = useContactAttributeOptions();

	if (isLoading) {
		return <Loading />;
	}

	return (
		<EditSortableLists
			initialItems={contactAttributeOptions}
			value={value}
			getLabel={(option) => option.name}
			onChange={onChange}
			listHeaders={{ active: t("Assigned contact attributes"), available: t("Available contact attributes") }}
			error={error}
		/>
	);
};
